const Loader = () => {
  return (
    <div className="loader7-container">
      <div className="loader7">
        <div className="inner-ring"></div>
      </div>
    </div>
  );
};

export default Loader;
